import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { APP_VERSION, INSTANCE_SLOT } from '../../config/runtimeConfig';

const AppVersionLabel = ({ sx = {} }) => {
  const { t } = useTranslation();

  if (!APP_VERSION) {
    return null;
  }

  return (
    <Typography
      variant="caption"
      color="text.secondary"
      title={`${APP_VERSION} (${INSTANCE_SLOT})`}
      sx={{
        display: 'block',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
        wordBreak: 'break-all',
        ...sx,
      }}
    >
      {t('common.appVersion', { version: APP_VERSION, slot: INSTANCE_SLOT })}
    </Typography>
  );
};

export default AppVersionLabel;
